import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";

function Sample2030000() {
  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="mini" sampleId="2030000" />
        <span> - </span>
        <SampleQuote text="Later, after they are married, Jack" targetIdx={21} targetLength={8} />
      </h4>
      <p>
        This circuit detects the end of a prepositional phrase and begins with Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2030000" featureKey="3.0.365" compact />, which
        fires on the word “after”. Downstream, through self-attention, Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2030000" featureKey="2.2.2819" compact /> fires on
        tokens immediately following “after”. These activations lead to Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2030000" featureKey="1.4.731" compact />, which
        responds most frequently to the verb within a prepositional phrase. In the penultimate
        layer, Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2030000" featureKey="0.7.2825" compact /> detects
        the end of a prepositional phrase and predicts that the next token will be a comma.
      </p>
      <figure>
        <figcaption>Detecting the End of Prepositional Phrases</figcaption>
        <ul className="tree">
          <li>
            <span className="node">
              <span className="feature">
                <FeatureAnchor
                  modelId="mini"
                  sampleId="2030000"
                  featureKey="0.7.2825"
                  compact={true}
                />
              </span>
              <span className="description">
                <SampleQuote
                  text="To facilitate rehydration,"
                  targetIdx={19}
                  targetLength={6}
                  quotes={false}
                  ellipsis={false}
                />
                <SampleQuote
                  text="after the ads were released,"
                  targetIdx={18}
                  targetLength={9}
                  quotes={false}
                  ellipsis={false}
                />
              </span>
            </span>
            <ul>
              <li>
                <span className="node">
                  <span className="feature">
                    <FeatureAnchor
                      modelId="mini"
                      sampleId="2030000"
                      featureKey="1.4.731"
                      compact={true}
                    />
                  </span>
                  <span className="description">
                    <SampleQuote
                      text="As we move,"
                      targetIdx={5}
                      targetLength={5}
                      quotes={false}
                      ellipsis={false}
                    />
                    <SampleQuote
                      text="by converting the"
                      targetIdx={2}
                      targetLength={11}
                      quotes={false}
                      ellipsis={false}
                    />
                    <SampleQuote
                      text="Before we forge"
                      targetIdx={9}
                      targetLength={6}
                      quotes={false}
                      ellipsis={false}
                    />
                  </span>
                </span>
                <ul>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="mini"
                          sampleId="2030000"
                          featureKey="2.2.2819"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote
                          text="before they pass"
                          targetIdx={6}
                          targetLength={5}
                          quotes={false}
                          ellipsis={false}
                        />
                        <SampleQuote
                          text="after it is"
                          targetIdx={5}
                          targetLength={3}
                          quotes={false}
                          ellipsis={false}
                        />
                      </span>
                    </span>
                    <ul>
                      <li>
                        <span className="node">
                          <span className="feature">
                            <FeatureAnchor
                              modelId="mini"
                              sampleId="2030000"
                              featureKey="3.0.365"
                              compact={true}
                            />
                          </span>
                          <span className="description">
                            <SampleQuote
                              text="shortly after the"
                              targetIdx={7}
                              targetLength={6}
                              quotes={false}
                              ellipsis={false}
                            />
                          </span>
                        </span>
                      </li>
                      <li>
                        <span className="node">
                          <span className="feature">
                            <FeatureAnchor
                              modelId="mini"
                              sampleId="2030000"
                              featureKey="2.1.461"
                              compact={true}
                            />
                          </span>
                          <span className="description">
                            <SampleQuote
                              text="knew they'd"
                              targetIdx={4}
                              targetLength={5}
                              quotes={false}
                              ellipsis={false}
                            />
                          </span>
                        </span>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="mini"
                          sampleId="2030000"
                          featureKey="1.3.1470"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote
                          text="Zoos are great"
                          targetIdx={4}
                          targetLength={4}
                          quotes={false}
                          ellipsis={false}
                        />
                      </span>
                    </span>
                    <ul>
                      <li>
                        <span className="node">
                          <span className="feature">
                            <FeatureAnchor
                              modelId="mini"
                              sampleId="2030000"
                              featureKey="1.0.2297"
                              compact={true}
                            />
                          </span>
                          <span className="description">
                            <SampleQuote
                              text="we are asking"
                              targetIdx={2}
                              targetLength={4}
                              quotes={false}
                              ellipsis={false}
                            />
                          </span>
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </figure>
    </section>
  );
}

export { Sample2030000 };
